var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 0 1296 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 160,
    height: 20,
    fill: "black",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 56,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 56,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 56,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 56,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 84,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 97,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 97,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 97,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 97,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 125,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 138,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 138,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 138,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 138,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 166,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 179,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 179,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 179,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 179,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    y: 207,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 220,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 220,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 220,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 220,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    y: 248,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    y: 261,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 261,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 261,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 261,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    y: 289,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    y: 302,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 302,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 302,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 302,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    y: 330,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    y: 343,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 343,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 343,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 343,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    y: 371,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    y: 384,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 384,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 384,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 384,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    y: 412,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    y: 425,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 425,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 425,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 425,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    y: 453,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    y: 466,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 466,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 466,
    width: 240,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 466,
    width: 160,
    height: 16,
    fill: "black",
    fillOpacity: 0.05
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    y: 494,
    width: 1296,
    height: 1,
    fill: "#DBDDE0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePlaceholder);
export default __webpack_public_path__ + "static/media/table_placeholder.3b6872ca5e244cadf1cc0aa56f5a8a63.svg";
export { ForwardRef as ReactComponent };